import type { Step } from 'react-joyride';

import {
    BlackWithAlpha,
    lightOrange,
    primaryOrange,
    warningTextColor,
} from '@/src/styles/theme/lightThemeOptions';

export type Device = 'mobile' | 'desktop';
type UserRole = 'Admin' | 'Power User' | 'User';

interface AppTourStep extends Omit<Step, 'title' | 'content'> {
    id: string;
    title: string;
    content: string;
    roles?: UserRole[];
    devices?: Device[];
}

export const allSteps: AppTourStep[] = [
    {
        id: 'input-container',
        target: '.input-container',
        title: 'steps.ask.title',
        content: 'steps.ask.content',
    },
    {
        id: 'chat-buttons',
        target: '.chat-buttons',
        title: 'steps.chatButtons.title',
        content: 'steps.chatButtons.content',
    },
    {
        id: 'deep-think',
        target: '.deep-think',
        title: 'steps.deepThink.title',
        content: 'steps.deepThink.content',
        spotlightPadding: {
            bottom: 10,
            left: 10,
            right: 0,
            top: 10,
        },
    },

    // Desktop-only steps
    {
        id: 'train',
        target: '.TRAIN',
        title: 'steps.train.title',
        content: 'steps.train.content',
        roles: ['Admin', 'Power User'],
        devices: ['desktop'],
    },
    {
        id: 'report',
        target: '.REPORT',
        title: 'steps.report.title',
        content: 'steps.report.content',
        roles: ['Admin'],
        devices: ['desktop'],
    },
    {
        id: 'manage',
        target: '.MANAGE',
        title: 'steps.manage.title',
        content: 'steps.manage.content',
        roles: ['Admin'],
        devices: ['desktop'],
    },
    {
        id: 'user-profile',
        target: '.user-profile',
        title: 'steps.userProfile.title',
        content: 'steps.userProfile.content',
    },

    // Mobile-only step
    {
        id: 'app-drawer',
        target: '.drawer-menu-icon',
        title: 'steps.appDrawer.title',
        content: 'steps.appDrawer.content',
        devices: ['mobile'],
    },

    {
        id: 'new-chat',
        target: '.new-chat',
        title: 'steps.newChat.title',
        content: 'steps.newChat.content',
        devices: ['desktop'],
    },
    {
        id: 'recent-chat',
        target: '.recent-chat',
        title: 'steps.recentChat.title',
        content: 'steps.recentChat.content',
        devices: ['desktop'],
    },
    {
        id: 'release-notes',
        target: '.release-notes',
        title: 'steps.releaseNotes.title',
        content: 'steps.releaseNotes.content',
        spotlightPadding: {
            bottom: 10,
            left: 10,
            right: 4,
            top: 10,
        },
    },
];

const buttonTextStyle = {
    fontSize: '14.4px',
    height: '32px',
    padding: '6px 12px',
    borderRadius: '5px',
};

export const joyrideStyles = {
    tooltipTitle: {
        fontSize: '16px',
        color: BlackWithAlpha(0.75),
        fontWeight: 700,
    },
    tooltipContent: {
        fontSize: '14px',
        color: warningTextColor,
        fontWeight: 400,
    },
    buttonPrimary: {
        ...buttonTextStyle,
        fontWeight: 700,
    },
    buttonBack: {
        ...buttonTextStyle,
        fontWeight: 600,
        border: `2px solid ${lightOrange}`,
    },
    buttonClose: { padding: '16px' },
};

export const joyrideOptions = {
    skipBeacon: true,
    showProgress: true,
    primaryColor: primaryOrange,
    zIndex: 1300,
};
